export const masterSchemas = {
  "filter-types": {
    title: "Filter Types",
    access: { roles: [1, 2], readOnly: false },
    schema: [
      { label: "Filter Type", name: "AssetType", type: "text", required: true },
      { label: "Note", name: "Note", type: "text", required: false },
      {
        label: "Status",
        name: "IsActive",
        type: "checkbox",
        required: false,
        default: true,
      },
    ],
    data: [
      {
        id: 101,
        key: 101,
        Sno: 1,
        AssetType: "HEPA Filter",
        Note: "High Efficiency Particulate Air filter",
        IsActive: true,
      },
      {
        id: 102,
        key: 102,
        Sno: 2,
        AssetType: "Carbon Filter",
        Note: "Used to remove odors and gases",
        IsActive: true,
      },
      {
        id: 103,
        key: 103,
        Sno: 3,
        AssetType: "Pre Filter",
        Note: "Captures large particles to extend HEPA filter life",
        IsActive: true,
      },
      {
        id: 104,
        key: 104,
        Sno: 4,
        AssetType: "Bag Filter",
        Note: "Medium efficiency filter used in HVAC systems",
        IsActive: true,
      },
      {
        id: 105,
        key: 105,
        Sno: 5,
        AssetType: "Panel Filter",
        Note: "Flat panel filter for basic filtration",
        IsActive: true,
      },
    ],
  },

  "maintenance-stages": {
    title: "Maintenance Stages",
    access: { roles: [1, 2], readOnly: false },
    schema: [
      { label: "Stage Name", name: "StageName", type: "text", required: true },
      {
        label: "Stage Order",
        name: "StageOrder",
        type: "number",
        required: true,
      },
      {
        label: "Description",
        name: "Description",
        type: "textarea",
        required: false,
      },
      // { label: 'Requires Signature', name: 'RequiresSignature', type: 'checkbox', required: false, default: false },
      {
        label: "Status",
        name: "IsActive",
        type: "checkbox",
        required: false,
        default: true,
      },
    ],
    data: [
      {
        id: 201,
        key: 201,
        StageName: "Inspection",
        Description: "Initial condition check before cleaning",
        StageOrder: 1,
        RequiresSignature: false,
        IsActive: true,
      },
      {
        id: 202,
        key: 202,
        StageName: "Wash-In",
        Description: "Start of washing cycle",
        StageOrder: 2,
        RequiresSignature: true,
        IsActive: true,
      },
      {
        id: 203,
        key: 203,
        StageName: "Wash-Out",
        Description: "Completion of washing cycle",
        StageOrder: 3,
        RequiresSignature: true,
        IsActive: true,
      },
      {
        id: 204,
        key: 204,
        StageName: "Dry-In",
        Description: "Start of drying cycle",
        StageOrder: 4,
        RequiresSignature: true,
        IsActive: true,
      },
      {
        id: 205,
        key: 205,
        StageName: "Dry-Out",
        Description: "Completion of drying cycle",
        StageOrder: 5,
        RequiresSignature: true,
        IsActive: true,
      },
      {
        id: 206,
        key: 206,
        StageName: "Storage-In",
        Description: "Clean filter moved to storage",
        StageOrder: 6,
        RequiresSignature: false,
        IsActive: true,
      },
      {
        id: 207,
        key: 207,
        StageName: "Installation",
        Description: "Filter installation ",
        StageOrder: 7,
        RequiresSignature: true,
        IsActive: true,
      },
      {
        id: 208,
        key: 208,
        StageName: "Replacement",
        Description: "Filter replaced at AHU",
        StageOrder: 8,
        RequiresSignature: true,
        IsActive: true,
      },
      {
        id: 209,
        key: 209,
        StageName: "Retirement",
        Description: "Filter retired from lifecycle",
        StageOrder: 9,
        RequiresSignature: true,
        IsActive: true,
      },
      {
        id: 210,
        key: 210,
        StageName: " Spare",
        Description: "Filter issued from storage for replacement",
        StageOrder: "-",
        RequiresSignature: true,
        IsActive: true,
      },
    ],
  },

  "filter-activities": {
    title: "Filter Activities",
    schema: [
      {
        label: "Activity Name",
        name: "ActivityName",
        type: "text",
        required: true,
      },
      {
        label: "Performed By",
        name: "PerformedBy",
        type: "text",
        required: false,
      },
      {
        label: "Status",
        name: "IsInternal",
        type: "checkbox",
        default: false,
      },
      // { name: 'CreatedBy', type: 'hidden', default: 1 }
    ],
    data: [
      {
        id: 301,
        key: 301,
        ActivityName: "Transfer",
        PerformedBy: "Admin",
        IsInternal: true,
      },
      {
        id: 302,
        key: 302,
        ActivityName: "Maintenance",
        PerformedBy: "Technician",
        IsInternal: false,
      },
    ],
  },

  "audit-activities": {
    title: "Application Audit Types",
    schema: [
      { label: "Audit Type", name: "AuditType", type: "text", required: true },
      { label: "Details", name: "Details", type: "textarea", required: false },
      { label: "Status", name: "IsEnabled", type: "checkbox", default: true },
      // { name: 'CreatedBy', type: 'hidden', default: 1 }
    ],
    data: [
      {
        id: 401,
        key: 401,
        AuditType: "Login Audit",
        Details: "Track user login/logout times and IP",
        IsEnabled: true,
      },
      {
        id: 402,
        key: 402,
        AuditType: "Permission Change Audit",
        Details: "Track role/permission changes",
        IsEnabled: true,
      },
    ],
  },

  "audit-activitiess": {
    title: "Application Audit Types",
    schema: [
      { label: "Audit Type", name: "AuditType", type: "text", required: true },
      { label: "Details", name: "Details", type: "textarea", required: false },
      { label: "Status", name: "IsEnabled", type: "checkbox", default: true },
      // { name: 'CreatedBy', type: 'hidden', default: 1 }
    ],
    data: [
      {
        id: 401,
        key: 401,
        AuditType: "Login Audit",
        Details: "Track user login/logout times and IP",
        IsEnabled: true,
      },
      {
        id: 402,
        key: 402,
        AuditType: "Permission Change Audit",
        Details: "Track role/permission changes",
        IsEnabled: true,
      },
    ],
  },

  "functional-locations": {
    title: "Functional Locations",
    access: { roles: [1, 2], readOnly: false },
    schema: [
      {
        label: "Block Name",
        name: "BlockName",
        type: "text",
        required: true,
      },
      {
        label: "Description",
        name: "Description",
        type: "textarea",
        required: false,
      },
      {
        label: "Status",
        name: "IsActive",
        type: "checkbox",
        default: true,
        required: false,
      },
    ],
    data: [
      {
        id: 501,
        key: 501,
        BlockName: "PFi Block",
        Description: "Main PFi operational block",
        IsActive: true,
      },
      {
        id: 502,
        key: 502,
        BlockName: "CWH Block",
        Description: "Central warehouse and logistics",
        IsActive: true,
      },
      {
        id: 503,
        key: 503,
        BlockName: "Block 3",
        Description: "Additional processing unit",
        IsActive: true,
      },
      {
        id: 504,
        key: 504,
        BlockName: "Block 4",
        Description: "Auxiliary services building",
        IsActive: true,
      },
    ],
  },

  "wash-in-reasons": {
    title: "Wash-In Reasons",
    access: { roles: [1, 2], readOnly: false },
    schema: [
      {
        label: "Reason",
        name: "Reason",
        type: "text",
        required: true,
      },
      {
        label: "Status",
        name: "IsActive",
        type: "checkbox",
        required: false,
        default: true,
      },
    ],
    data: [
      { id: 601, key: 601, Reason: "Type-C Clearance", IsActive: true },
      { id: 602, key: 602, Reason: "Preventive Maintenance", IsActive: true },
      { id: 603, key: 603, Reason: "Routine Cleaning", IsActive: true },
      { id: 604, key: 604, Reason: "Emergency Wash-In", IsActive: false },
    ],
  },

  "wash-equipment-list": {
    title: "Wash In Equipment List",
    access: { roles: [1, 2], readOnly: false },
    schema: [
      {
        label: "Equipment Name",
        name: "EquipmentName",
        type: "text",
        required: true,
      },
      {
        label: "Active",
        name: "IsActive",
        type: "checkbox",
        required: false,
        default: true,
      },
    ],
    data: [
      { id: 801, key: 801, EquipmentName: "Machine01", IsActive: true },
      { id: 802, key: 802, EquipmentName: "Machine02", IsActive: true },
      { id: 803, key: 803, EquipmentName: "Machine03", IsActive: true },
    ],
  },

  "dryer-equipment-id": {
    title: "Dryer Equipments",
    access: { roles: [1, 2], readOnly: false },
    schema: [
      {
        label: "Equipment ID",
        name: "EquipmentId",
        type: "text",
        required: true,
      },
      {
        label: "Dryer Unit Name", // ✅ Updated field for filter context
        name: "DryerUnitName",
        type: "text",
        required: true,
      },
      {
        label: "Status",
        name: "IsActive",
        type: "checkbox",
        required: false,
        default: true,
      },
    ],
    data: [
      {
        id: 601,
        key: 601,
        EquipmentId: "CHW/01",
        DryerUnitName: "CHW Dryer Unit A", // ✅ Example contextual value
        IsActive: true,
      },
      {
        id: 602,
        key: 602,
        EquipmentId: "HW02",
        DryerUnitName: "Hot Water Dryer B", // ✅ Example contextual value
        IsActive: false,
      },
    ],
  },
  "air-pressure-limit": {
    title: "Air Pressure Limit",
    unitsSource: "air-pressure-units",
    access: { roles: [1, 2], readOnly: false },
    schema: [
      {
        label: "Minimum Value",
        name: "Min",
        type: "number",
        required: true,
      },
      {
        label: "Maximum Value",
        name: "Max",
        type: "number",
        required: true,
      },
      {
        label: "Step",
        name: "Step",
        type: "number",
        required: true,
      },
    ],
    data: [
      {
        id: 1,
        key: 1,
        Min: 0.1,
        Max: 7.0,
        Step: 0.1,
      },
    ],
  },

  "ro-water-pressure": {
    title: "RO Water Pressure ",
    access: { roles: [1, 2], readOnly: false },
    unitsSource: "ro-water-pressure-units",
    schema: [
      { label: "Minimum Value", name: "Min", type: "number", required: true },
      { label: "Maximum Value", name: "Max", type: "number", required: true },
      { label: "Step", name: "Step", type: "number", required: true },
    ],
    data: [{ id: 2, key: 2, Min: 0.1, Max: 7.0, Step: 0.1 }],
  },

  "air-pressure-units": {
    title: "Air Pressure Units",
    access: { roles: [1, 2], readOnly: false },
    schema: [
      {
        label: "Unit",
        name: "Unit",
        type: "text",
        default: "Bar",
        required: true,
      },
    ],
    data: [{ id: 701, key: 701, Unit: "Bar" }],
  },

  "ro-water-pressure-units": {
    title: "RO Water Pressure Units",
    access: { roles: [1, 2], readOnly: true },
    schema: [
      {
        label: "Unit",
        name: "Unit",
        type: "text",
        default: "Bar",
        required: true,
      },
    ],
    data: [{ id: 702, key: 702, Unit: "Bar" }],
  },

  "dryer-temperature-range": {
    title: "Dryer Temperature Range",
    unitsSource: "dryer-temperature-units",
    access: { roles: [1, 2], readOnly: false },
    schema: [
      {
        label: "Minimum Temperature (°C)",
        name: "Min",
        type: "number",
        required: true,
      },
      {
        label: "Maximum Temperature (°C)",
        name: "Max",
        type: "number",
        required: true,
      },
      { label: "Step", name: "Step", type: "number", required: true },
    ],
    data: [{ id: 3, key: 3, Min: 25.5, Max: 60.6, Step: 0.1 }],
  },

  "minimum-dryer-duration": {
    title: "Minimum Dryer Duration",
    access: { roles: [1, 2], readOnly: false },
    schema: [
      {
        label: "Minimum Duration (s)",
        name: "Min",
        type: "number",
        required: true,
      },
      {
        label: "Maximum Duration (s)",
        name: "Max",
        type: "number",
        required: true,
      },
      { label: "Step", name: "Step", type: "number", required: true },
    ],
    data: [{ id: 4, key: 4, Min: 0, Max: 65535, Step: 1 }],
  },

  "dryer-temperature-units": {
    title: "Dryer Temperature Units",
    access: { roles: [1, 2], readOnly: true },
    schema: [
      {
        label: "Unit",
        name: "Unit",
        type: "text",
        default: "Celsius",
        required: true,
      },
    ],
    data: [
      { id: 703, key: 703, Unit: "Celsius" },
      // { id: 704, key: 704, Unit: "Fahrenheit" },
      // { id: 705, key: 705, Unit: "Kelvin" },
      // { id: 706, key: 706, Unit: "Rankine" },
    ],
  },
};
